// Real content from coach-sportif-fasciatherapie.fr
// Site name: Fasciathérapie & Sport Santé

// Real images from the original site (Wix CDN)
export const realImages = {
  hero: "https://static.wixstatic.com/media/47ea5f_5dd53a35c48e41b589a449785b83b386~mv2.jpg/v1/fill/w_900,h_1120,al_c,q_85,enc_avif,quality_auto/IMG-20260414-WA0114.jpg",
  fasciaSession: "https://static.wixstatic.com/media/47ea5f_c703aa75f7ae4360ba27023c67e111bf~mv2.jpg/v1/fill/w_900,h_1120,al_c,q_85,enc_avif,quality_auto/IMG-20260414-WA0032.jpg",
  fasciaKnee: "https://static.wixstatic.com/media/47ea5f_92412b1c64eb40458af4b37253d97c47~mv2.jpg/v1/fill/w_900,h_1200,al_c,q_85,enc_avif,quality_auto/47ea5f_92412b1c64eb40458af4b37253d97c47~mv2.jpg",
  fasciaKnee2: "https://static.wixstatic.com/media/47ea5f_28b2ceb9a7e647608797302d39b43a97~mv2.jpg/v1/fill/w_900,h_1200,al_c,q_85,enc_avif,quality_auto/IMG-20260414-WA0012.jpg",
  portrait: "https://static.wixstatic.com/media/47ea5f_f68fdff4444f4ecc86213234b39761a4~mv2.png/v1/fill/w_600,h_640,al_c,q_85,enc_avif,quality_auto/Design%20sans%20titre.png",
  portrait2: "https://static.wixstatic.com/media/47ea5f_f5389ff50a0d41e39e440fb2ad40ff5f~mv2.png/v1/fill/w_600,h_640,al_c,q_85,enc_avif,quality_auto/47ea5f_f5389ff50a0d41e39e440fb2ad40ff5f~mv2.png",
  medicineBall: "https://static.wixstatic.com/media/47ea5f_131c27386dae4156abb37394315c7a26~mv2.jpg/v1/fill/w_1200,h_600,al_c,q_85,enc_avif,quality_auto/47ea5f_131c27386dae4156abb37394315c7a26~mv2.jpg",
  strengthMedball: "https://static.wixstatic.com/media/47ea5f_41c3bec9def041ecbd96d0153fd8e4c8~mv2.jpg/v1/fill/w_900,h_675,al_c,q_85,enc_avif,quality_auto/IMG-20241205-WA0078.jpg",
  seniorCurls: "https://static.wixstatic.com/media/47ea5f_d9e3715ce9b447fd922ef20d853585a7~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/47ea5f_d9e3715ce9b447fd922ef20d853585a7~mv2.jpg",
  seniorChair: "https://static.wixstatic.com/media/47ea5f_29d1ff1c0da44d25a1f91b6936d4e730~mv2.jpg/v1/fill/w_900,h_675,al_c,q_85,enc_avif,quality_auto/47ea5f_29d1ff1c0da44d25a1f91b6936d4e730~mv2.jpg",
  seniorCurl2: "https://static.wixstatic.com/media/47ea5f_0642ad6104ed4801833a73a17154e07c~mv2.jpg/v1/fill/w_900,h_675,al_c,q_85,enc_avif,quality_auto/47ea5f_0642ad6104ed4801833a73a17154e07c~mv2.jpg",
  trx: "https://static.wixstatic.com/media/47ea5f_df794471d6a44851a77053cd2351b86b~mv2.jpg/v1/fill/w_900,h_675,al_c,q_85,enc_avif,quality_auto/47ea5f_df794471d6a44851a77053cd2351b86b~mv2.jpg",
  kneesPain: "https://static.wixstatic.com/media/47ea5f_ae398a4fa39242d4af77962d7bf9fc80~mv2.jpg/v1/fill/w_1200,h_600,al_c,q_85,enc_avif,quality_auto/47ea5f_ae398a4fa39242d4af77962d7bf9fc80~mv2.jpg",
  anklePain: "https://static.wixstatic.com/media/47ea5f_f22434f2745a4efdaae010ba2e294ed7~mv2.jpg/v1/fill/w_1200,h_600,al_c,q_85,enc_avif,quality_auto/47ea5f_f22434f2745a4efdaae010ba2e294ed7~mv2.jpg",
  lowBackPain: "https://static.wixstatic.com/media/47ea5f_2003c86100c54207b9854723b645a0e6~mv2.jpg/v1/fill/w_1200,h_600,al_c,q_85,enc_avif,quality_auto/47ea5f_2003c86100c54207b9854723b645a0e6~mv2.jpg",
  cervicalPain: "https://static.wixstatic.com/media/47ea5f_db419cfdcd4341b3ab9cb4335f59aba7~mv2.jpg/v1/fill/w_1200,h_600,al_c,q_85,enc_avif,quality_auto/47ea5f_db419cfdcd4341b3ab9cb4335f59aba7~mv2.jpg",
  mobilityHome: "https://static.wixstatic.com/media/47ea5f_33b8a19552174068ad20dea4a1430fa4~mv2.jpg/v1/fill/w_1200,h_760,al_c,q_85,enc_avif,quality_auto/remise%20en%20forme.jpg",
  backPain: "https://static.wixstatic.com/media/47ea5f_629101d3ae7e4d8481a20020046ba682~mv2.jpg/v1/fill/w_1200,h_650,al_c,q_85,enc_avif,quality_auto/47ea5f_629101d3ae7e4d8481a20020046ba682~mv2.jpg",
  googleReview: "https://static.wixstatic.com/media/47ea5f_74b93135bf204fe1b173c3242ae1063d~mv2.jpg/v1/fill/w_200,h_200,al_c,q_85,enc_avif,quality_auto/47ea5f_74b93135bf204fe1b173c3242ae1063d~mv2.jpg",
};

export const siteData = {
  brand: {
    name: "Fasciathérapie & Sport Santé",
    shortName: "F&SS",
  },
  practitioner: {
    name: "Jean-Christophe HAPPILLON",
    title: "Coach sportif & Praticien en fasciathérapie",
    location: "Toulouse & Saint-Orens",
    experience: "10+",
    phone: "07 82 47 63 36",
    rating: "5/5",
    reviewsCount: 41,
    patientsHelped: "400+",
    photo: realImages.portrait,
    address: "5 bis rue du négoce, 31650 Saint-Orens",
  },
  google: {
    cid: "12787876457190320191",
    profileUrl: "https://www.google.com/maps?cid=12787876457190320191",
    writeReviewUrl: "https://search.google.com/local/writereview?cid=12787876457190320191",
    seeAllReviewsUrl: "https://search.google.com/local/reviews?cid=12787876457190320191",
  },
  hero: {
    kicker: "Fasciathérapie & Sport santé à Toulouse",
    title: "Fasciathérapie & Coaching sportif à domicile à Toulouse",
    subtitle:
      "Soulagez vos douleurs chroniques et retrouvez la mobilité. J'accompagne à domicile ou au cabinet de Saint-Orens : fasciathérapie (méthode Tissual Balancing) et coaching sport santé.",
    ctaPrimary: "Réserver mon bilan",
    ctaSecondary: "07 82 47 63 36",
    heroImage: realImages.hero,
    heroImage2: realImages.fasciaSession,
  },
  badges: [
    { label: "10 ans d'expérience", desc: "Coach diplômé DEUG STAPS" },
    { label: "Séances personnalisées", desc: "Chaque séance adaptée à vous" },
    { label: "Soulagement rapide", desc: "Dès la première séance" },
    { label: "À domicile ou cabinet", desc: "Toulouse & Saint-Orens" },
  ],
  specialties: [
    {
      title: "Mal de dos",
      desc: "Lombalgie, cervicalgie, hernie discale, sciatique : j'agis sur les chaînes fasciales pour un soulagement durable.",
      icon: "activity",
      img: realImages.lowBackPain,
    },
    {
      title: "Tensions musculaires",
      desc: "Raideurs, contractures, décharges : libération en profondeur des fascias pour retrouver de la souplesse.",
      icon: "move",
      img: realImages.mobilityHome,
    },
    {
      title: "Stress et fatigue",
      desc: "Relâchement profond, sommeil amélioré. La fasciathérapie apaise le système nerveux.",
      icon: "heart-pulse",
      img: realImages.fasciaSession,
    },
    {
      title: "Douleurs articulaires",
      desc: "Épaules, hanches, genoux : soulagement et retour de la mobilité par la méthode Tissual Balancing.",
      icon: "users",
      img: realImages.kneesPain,
    },
    {
      title: "Maux de tête et migraines",
      desc: "Diminution des tensions cervicales et de la fréquence des céphalées de tension.",
      icon: "shield",
      img: realImages.cervicalPain,
    },
    {
      title: "Reprise d'activité",
      desc: "Préparation ou retour au mouvement en sécurité après blessure, opération ou rééducation.",
      icon: "stethoscope",
      img: realImages.strengthMedball,
    },
  ],
  painPoints: [
    "Vous ressentez des raideurs ou une perte de mobilité",
    "Des maux de dos récurrents qui limitent vos mouvements",
    "Des douleurs persistantes malgré kiné, ostéo, anti-inflammatoires",
    "Un manque d'énergie et de vitalité au quotidien",
    "Une envie de reprendre le sport en sécurité, sans risquer la récidive",
  ],
  about: {
    title: "Votre coach & praticien",
    intro:
      "Après plus de 10 ans à encadrer kayak, escalade, marche nordique et canyoning, j'ai observé un public qui a des difficultés à bien bouger, des personnes avec des douleurs et un mouvement limité. C'est pourquoi j'ai décidé d'agir avec une approche différente.",
    bio:
      "J'associe le coaching sportif adapté à la fasciathérapie de la méthode Tissual Balancing pour vous soulager, là où d'autres méthodes n'ont pas fonctionné. Mon objectif : vous aider à comprendre les mécanismes de votre corps pour retrouver mobilité, bien-être et prévenir la récidive.",
    duration: "60-90",
    price: "60-90",
    creditImpot: "50%",
    certifications: [
      "DEUG STAPS",
      "Préparateur physique (SSCS training)",
      "Coach mobilité (ABD formation)",
      "Sport santé (CAP formations sport)",
      "APA maux de dos",
      "APA endométriose",
      "Fasciathérapie (Tissual Balancing academy)",
    ],
  },
  process: [
    { step: 1, title: "Un échange approfondi", desc: "J'écoute votre histoire, vos symptômes, habitudes et objectifs pour bien vous connaître." },
    { step: 2, title: "Bilan de mobilité", desc: "Tests de mobilité et physiques pour évaluer les zones qui vous limitent et votre niveau de forme." },
    { step: 3, title: "Soin & mouvement", desc: "Séance de fasciathérapie douce et/ou coaching adapté à vos besoins." },
    { step: 4, title: "Conseils personnalisés", desc: "Exercices et recommandations pour prolonger les bienfaits et prévenir les récidives." },
  ],
  reviews: [
    { name: "Paola", city: "Toulouse", text: "Je viens de terminer ma première séance avec Jean-Christophe pour une douleur continue depuis plus d'un an aux lombaires. Aucun traitement n'avait eu d'effet jusqu'à aujourd'hui... dès la fin de la séance ma douleur a diminué considérablement, c'est presque magique.", rating: 5 },
    { name: "Danièle", city: "Quint-Fonsegrives", text: "Essayer c'est l'adopter, excellent praticien dont les qualités sont indéniables.", rating: 5 },
    { name: "Orianne", city: "Saint-Orens", text: "Deuxième séance de fasciathérapie avec Jean-Christophe et des résultats toujours aussi bluffants. Le tout, dans une approche très humaine et bienveillante. Merci !", rating: 5 },
    { name: "Alicia, 34 ans", city: "Montaudran", text: "Cours agréables, parfaitement adaptés à mes besoins. La cerise sur le gâteau : en plus du coaching il me fait aussi de la fasciathérapie à domicile. N'hésitez pas !", rating: 5 },
    { name: "Jacqueline, 76 ans", city: "Quint-Fonsegrives", text: "Jean-Christophe est vraiment un excellent coach, très professionnel et sérieux. Il s'adapte à toutes les situations et propose toujours un programme adapté. Je recommande vivement.", rating: 5 },
    { name: "Léa, 30 ans", city: "Toulouse", text: "La fasciathérapie a permis d'atténuer la tension provoquée par la tendinite, et les exercices me permettent de me remuscler en douceur. Il est à l'écoute, très pédagogue.", rating: 5 },
    { name: "Jérémy, 36 ans", city: "Toulouse", text: "Approche différente et personnalisée. Je n'ai plus de douleurs cervicales depuis. Je fais désormais appel à JC régulièrement.", rating: 5 },
  ],
  pricing: {
    fasciatherapie: [
      { title: "Première séance", duration: "1h30", price: "90€", features: ["Bilan complet", "Évaluation de la posture", "Soin des fascias", "Exercices personnalisés"] },
      { title: "Séance de suivi", duration: "1 heure", price: "60€", features: ["Travail ciblé", "Libération articulaire", "Apaisement durable des tensions", "Conseils personnalisés"], highlight: true },
    ],
    coaching: [
      { title: "Bilan de forme", duration: "1 heure", price: "Offert", features: ["Échange & anamnèse", "Tests de mobilité", "Tests physiques", "Présentation crédit d'impôt"] },
      { title: "Cours 40 min", duration: "40 minutes", price: "20€", realPrice: "40€", features: ["Séance à domicile", "Programme adapté", "Suivi personnalisé", "50% crédit d'impôt"] },
      { title: "Cours 1h", duration: "1 heure", price: "29€", realPrice: "58€", features: ["Séance à domicile", "Programme complet", "Suivi personnalisé", "50% crédit d'impôt"], highlight: true },
    ],
  },
  faq: [
    { q: "À quoi s'attendre lors de la première séance ?", a: "La première séance dure environ 1h30. Nous commençons par un échange approfondi sur votre histoire, vos symptômes, vos habitudes de vie et vos objectifs. Je réalise ensuite un bilan de mobilité et des tests posturaux pour identifier les zones de tension. Vient enfin le soin manuel doux (fasciathérapie) ou une séance de mise en mouvement adaptée, suivi de conseils personnalisés et de 2-3 exercices simples à reproduire chez vous." },
    { q: "Vos offres sont-elles sans engagement ?", a: "Oui, la fasciathérapie et les cours de sport à domicile sont sans engagement. Vous êtes libre de choisir votre rythme en fonction de vos disponibilités et envies." },
    { q: "Où vous déplacez-vous ?", a: "Je me déplace à Toulouse, Quint-Fonsegrives, Balma, Saint-Orens, Labège, Escalquens, L'Union, Saint-Jean, Flourens, Drémil-Lafage, Ramonville, Castanet-Tolosan, quartier Montaudran et environs." },
    { q: "Quelle est la différence avec l'ostéopathie ?", a: "L'ostéopathie est plus large et parfois mécanique. La fasciathérapie est plus douce et centrée sur les tissus. Pas de craquement, pas de manipulation brusque. Le Tissual Balancing travaille en douceur sur les tissus mous." },
    { q: "Quels moyens de paiement acceptez-vous ?", a: "Espèces, chèques, cartes bancaires, virements bancaires, et prélèvements bancaires (uniquement pour les cours de sport à domicile bénéficiant du crédit d'impôt SAP)." },
    { q: "Quel est le délai pour annuler une séance ?", a: "Jusqu'à 48h avant le rendez-vous, l'annulation est gratuite. Moins de 48h avant, la séance sera facturée en totalité." },
  ],
  zones: [
    "Toulouse", "Saint-Orens", "Quint-Fonsegrives", "Balma", "Labège", "Montaudran",
    "L'Union", "Ramonville", "Castanet-Tolosan", "Escalquens", "Flourens", "Drémil-Lafage",
  ],
};
